import { render, staticRenderFns } from "./bookingManifestVGMInfo.vue?vue&type=template&id=278a2346&"
import script from "./bookingManifestVGMInfo.vue?vue&type=script&lang=js&"
export * from "./bookingManifestVGMInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278a2346')) {
      api.createRecord('278a2346', component.options)
    } else {
      api.reload('278a2346', component.options)
    }
    module.hot.accept("./bookingManifestVGMInfo.vue?vue&type=template&id=278a2346&", function () {
      api.rerender('278a2346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/bookingManifestVGMInfo.vue"
export default component.exports